export default "__VITE_ASSET__1IZiOaxs__"